<script lang="ts">
  import Grid from "../Grid/Grid.svelte";

  export let reverse: boolean = false;
  export let smCols: number = 4; // Default to 12 columns for mobile
  export let mdCols: number = 8; // Default to 12 columns for tablet
  export let lgCols: number = 12; // Default to 6 columns for each side
  export let xlCols: number = 12; // Default to 6 columns for each side
  export let xxlCols: number = 12; // Default to 12 columns for extra large screens

  export let smGap: string = "40px";
  export let mdGap: string = "40px";
  export let lgGap: string = "48px";
  export let xlGap: string = "64px";
  export let xxlGap: string = "72px";
</script>

<Grid
  {smCols}
  {mdCols}
  {lgCols}
  {xlCols}
  {xxlCols}
  {smGap}
  {mdGap}
  {lgGap}
  {xlGap}
  {xxlGap}
>
  {#if reverse}
    <slot name="left" />
    <slot name="right" />
  {:else}
    <slot name="right" />
    <slot name="left" />
  {/if}
</Grid>
